<div class="main">
    <div class="section">
        <div class="header">
            <div class="welcome">
                <div><img src="assets/say_hello_icon.png" alt="" style="width: 76px;"></div>
                <!-- <div> <app-json-animator path="assets/Hand_Wiggle.json">
                </app-json-animator></div> -->
                <div class="welcome_text">{{'LANDINGPAGE.welcomeText' | translate}}</div>
            </div>
            
            <div class="help_info">{{'LANDINGPAGE.helpInfo' | translate}}</div>
        </div>
        <div class="menu_actions">
            <div>
                <div class="quick_actions">{{'LANDINGPAGE.quickActions' | translate}}</div>
                <div class="cards">
                    <div class="item hover_effect_dashboard" routerLink="/overview">
                        <div class="card_header">
                            <div class="navigate">
                                <div> <img src="assets/Dashboard_icon.svg" alt="" class="side_icon"> </div>
                                <div class="card_title"> {{'LANDINGPAGE.Dashboard' | translate}} </div>
                            </div>
                            <div><img src="assets/Arrow_icon.svg" alt=""></div>
                        </div>
                        <div class="content">{{'LANDINGPAGE.dashboardInfo' | translate}}</div>
                    </div>
                    <div class="item hover_effect_orders" routerLink="/dashboard">
                        <div class="card_header">
                            <div class="navigate">
                                <div> <img src="assets/orders_icon.svg" alt="" class="side_icon"> </div>
                                <div class="card_title"> {{'LANDINGPAGE.Orders' | translate}} </div>
                            </div>
                            <div><img src="assets/Arrow_icon.svg" alt=""></div>
                        </div>
                        <div class="content">{{'LANDINGPAGE.ordersInfo' | translate}}</div>
                    </div>
                    <div class="item hover_effect_shipments" routerLink="/shipmentsDashboard">
                        <div class="card_header">
                            <div class="navigate">
                                <div> <img src="assets/Shipments_icon.svg" alt="" class="side_icon"> </div>
                                <div class="card_title"> {{'LANDINGPAGE.Shipments' | translate}} </div>
                            </div>
                            <div><img src="assets/Arrow_icon.svg" alt=""></div>
                        </div>
                        <div class="content">{{'LANDINGPAGE.shipmentsInfo' | translate}}</div>
                    </div>
                    <div class="item hover_effect_postorder" routerLink="/postShipment">
                        <div class="card_header">
                            <div class="navigate">
                                <div> <img src="assets/post_order_icon.svg" alt="" class="side_icon"> </div>
                                <div class="card_title"> {{'LANDINGPAGE.postOrder' | translate}} </div>
                            </div>
                            <div><img src="assets/Arrow_icon.svg" alt=""></div>
                        </div>
                        <div class="content">{{'LANDINGPAGE.postOrderInfo' | translate}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="whats_new">
            <div class="whats_new_sec">
            <div class="whats_new_header">
                <div class="circle"> 
                    <ng-lottie width="24px" height="24px" [options]="{
                    path: path, 
                    renderer: 'svg', 
                    autoplay: true, 
                    loop: true
                  }"></ng-lottie></div>
                <div class="whatnew_title">{{'LANDINGPAGE.whatsNew' | translate}}</div>
            </div>
              <div class="content">
                <ol type="1" class="updates_sec">
                    <!-- <li class="update_status">Coming Soon</li> -->
                    <div class="update_status">{{'LANDINGPAGE.comingSoon' | translate}}</div>
                </ol>  
              </div>
              
            </div>
          </div>
    </div>
</div>
